import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

// 이미지 소프트 딜리트
// 백엔드단으로부터의 전달사항: http 메소드 중 DELETE의 경우 단일 삭제에 표준적으로 사용하며 삭제 대상 식별 정보는 보통 URL (QueryString, Parameter)로 전달하는 것이 일반적이고, 여러 id를 삭제하는 payload가 자연스러운 케이스는 POST 메소드를 사용하여 배열 body로 전달하는 것이 권장되므로 해당 API의 경우 POST 메소드를 채택함
async function postImageBulkDelete(variables: { imageId: number[] }): Promise<AxiosResponse<FetchResult<string>>> {
  const response = instance.post(`/images/bulk-delete`, variables);
  return response;
}

const usePostImagesBulkDelete = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['post', `/images/bulk-delete`],
    mutationFn: (variables: { imageId: number[] }) => postImageBulkDelete(variables),
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePostImagesBulkDelete;
